import { RadioItem } from '@app/shared/ui/atoms/Admin';

interface RadioGroupProps<T> {
  items: { value: T; label?: string; icon?: string }[];
  value: T;
  onValueChange: (value: T) => void;
}

export function RadioGroup<T extends string>({ items, value, onValueChange }: RadioGroupProps<T>) {
  return (
    <div className="flex flex-wrap gap-2">
      {items.map((item) => (
        <RadioItem
          key={item.value}
          label={item.label}
          icon={item.icon}
          isActive={item.value === value}
          onClick={() => onValueChange(item.value)}
        />
      ))}
    </div>
  );
}
